import Mutations from '../../odata/mutations';

export default { ...new Mutations('contractAttachment'), ...new Mutations('contractAttachments') };
